// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/OrderCompleteModal/style.css
// module id = 1890
// module chunks = 0